<template>
<div class="chapter">
<div class="inner_page">
<p class="centerImage1"><a id="map1"></a><img alt="images" src="images/map-1.jpg"/></p>
<p class="caption"><em class="italic">Plan of the battles of Tel-el-Kebir and Kassassin, 1882</em>. <span class="smallcaps">(From Sir Evelyn Wood, <em class="italic">British Battles on Land and Sea</em>, London: Cassell &amp; Co., 1915)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_chapter011.vue?011f3de5